export interface Brand {
    id: number;
    name: string;
    logo_url: string;
  }
  
  export const BRANDS_DATA: Brand[] = [
    { id: 1, name: "VPS Textile", logo_url: "https://cdn-icons-png.flaticon.com/512/3063/3063822.png" },
    { id: 2, name: "C.K.TEX", logo_url: "https://cdn-icons-png.flaticon.com/512/2147/2147131.png" },
    { id: 3, name: "VVP Tex", logo_url: "https://cdn-icons-png.flaticon.com/512/3461/3461380.png" },
    { id: 4, name: "JP Tex", logo_url: "https://cdn-icons-png.flaticon.com/512/2503/2503380.png" },
    { id: 5, name: "SRM Fabrics", logo_url: "https://cdn-icons-png.flaticon.com/512/4232/4232111.png" },
    { id: 6, name: "Lotus Weaves", logo_url: "https://cdn-icons-png.flaticon.com/512/10432/10432174.png" },
    { id: 7, name: "Quality Knits", logo_url: "https://cdn-icons-png.flaticon.com/512/9639/9639645.png" },
    { id: 8, name: "Classic Cotton", logo_url: "https://cdn-icons-png.flaticon.com/512/2903/2903653.png" }
  ];